import React from 'react';
import TagsInput from 'react-tagsinput'

import PropTypes from 'prop-types';

const isTagLocked = (tag, lockedTags) => !!lockedTags.find(locked => locked === tag);

class ArticleTags extends React.Component {

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.arrayOf(PropTypes.string).isRequired
  };

  static defaultProps = {
    value: [],
    lockedTags: []
  };

  componentDidMount() {
    const { lockedTags } = this.props;
    this.setState({lockedTags: [...lockedTags]});
  }

  handleChange(tags) {
    this.setState({tags})
    const { onChange } = this.props;
    onChange(tags);
  }

  defaultRenderTag (props, lockedTags) {
    let {tag, key, disabled, onRemove, classNameRemove, getTagDisplayValue, ...other} = props
    console.log(tag, key, lockedTags);
    return (
      <span key={key} {...other}>
        {getTagDisplayValue(tag)}
        {!disabled && !isTagLocked(tag, lockedTags) &&
          <a className={classNameRemove} onClick={(e) => {
            if(!isTagLocked(key, lockedTags)) {
              onRemove(key);
            }
          }} />
        }
      </span>
    )
  }

  render() {
    const { value, lockedTags } = this.props;
    const TAG_VALIDATION_REGEX = /^(?=.{2,24}$)([[a-z][a-z0-9]*-?[a-z0-9]+)$/;
    return (
      <TagsInput
        value={value}
        onChange={this.handleChange.bind(this)}
        validationRegex={TAG_VALIDATION_REGEX}
        maxTags={15}
        addOnBlur={true}
        onlyUnique={true}
        removeKeys={[]}
        renderTag={ (props) => this.defaultRenderTag(props, lockedTags)}
        addKeys={[9, 13, 32]} // tab, enter, space
      />
    )
  }
}

const renderArticleTags = (props) => {
  const { input, meta: { touched, error }, lockedTags } = props;
  console.log(props);
  return (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
      <ArticleTags {...input} lockedTags={lockedTags} />
      {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
  );
};

renderArticleTags.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    name: PropTypes.string,
    value: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  lockedTags: PropTypes.arrayOf(PropTypes.string),
};

renderArticleTags.defaultProps = {
  meta: null
};

export default renderArticleTags;
